import "../../css/components/Bubbles.scss";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Swiper from "react-id-swiper";
import Link from "./Link";
import g from "../utils/globals";

class Bubbles extends Component {
  constructor() {
    super();
    this.swiper = null;
    this.params = {
      freeMode: true,
      slidesPerView: "auto",
      watchOverflow: true,
      speed: 1000,
    };
  }

  render = () => (
    <div id="bubble-carousel" dir={g.direction}>
      <Swiper {...this.params}>
        {this.props.contents.map((bubble, k) => {
          if (!bubble.targetUrlText) return null;

          if (g.editMode) {
            return (
              <span key={k} className="bubble-container">
                <img {...bubble.attrs} className="bubble" />
                <div className="bubble-text">{bubble.targetUrlText}</div>
              </span>
            );
          }

          if (!bubble.targetUrl) return null;
          const analytics = {
            origin: "MINIHOME",
            category: "Home",
            action: "Click_Minihome",
            label: `${bubble.targetUrlText ? bubble.targetUrlText.replace(/\n/gi, "").trim() : ""}-${bubble.dataAttrs["data-category"]}`,
          };
          return (
            <Link
              key={k}
              href={bubble.targetUrl}
              className="bubble-container"
              dataAttrs={bubble.dataAttrs}
              index={k}
              analytics={analytics}
              analyticsPerView={false}
            >
              <img {...bubble.attrs} className="bubble" />
              <div className="bubble-text">{bubble.targetUrlText}</div>
            </Link>
          );
        })}
      </Swiper>
    </div>
  );
}

Bubbles.propTypes = {
  onPageChange: PropTypes.func,
};

export default Bubbles;
